export default {
  setUsg(state, data) {
    state.usg = data
  },
  setPatientJustify(state, data) {
    state.patientJustify = data
  }
}
